<div role="tabpanel" class="tabs">
  <div class="tabs-header">
    <div class="nav nav-tabs tabs__tab-bar has-2-tabs" role="tablist">
      <button class="tabs__tab-bar-button tabs__tab-bar-button--active" href="#course_map_pane" id="course_map" role="tab" data-toggle="tab">
        <p class="tabs__tab-bar-button__text">Course Map</p>
      </button>
      <button class="tabs__tab-bar-button" href="#accessibility_pane" id="accessibility" role="tab" data-toggle="tab">
        <p class="tabs__tab-bar-button__text">Accessibility</p>
      </button>
    </div>
    <div class="tabs-header-buttons inline-block">
      <button type="button" id="guides-overlay-button" class="btn btn-secondary btn-compact guides-overlay-button disableMargin" data-close="true">Enable Guides Overlay</button>
      <a href="#" class="pull-right btn btn-secondary btn-compact home-button" data-close="true">Home</a>
      <div class="page-skipping-container text-right inline-block">
        <p class="p3 bold inline-block">Page Skipping:</p>
        <div class="btn-group inline-block" data-toggle="buttons">
          <label class="btn btn-tertiary btn-compact disableMargin {{#if pageSkipping}}active{{/if}}">
            <input type="radio" name="page-skipping" id="allowed" autocomplete="off" {{#if pageSkipping}}checked{{/if}} value="true">Allow
          </label>
          <label class="btn btn-tertiary btn-compact disableMargin {{#unless pageSkipping}}active{{/unless}}">
            <input type="radio" name="page-skipping" id="prevented" autocomplete="off" {{#unless pageSkipping}}checked{{/unless}} value="false">Prevent
          </label>
        </div>
      </div>
      <button type="button" class="btn btn-tertiary" data-close="true">
        {{>icon uuid=cid icon="fal fa-times" size="fa-lg"}}
        <span class="sr-only">Close</span>
      </button>
    </div>
  </div>
  <div class="tabs__tab-content p-inset-none">
    <div role="tabpanel" class="tabs__tab-content__tab-pane disablePadding active" id="course_map_pane"></div>
    <div role="tabpanel" class="tabs__tab-content__tab-pane" id="accessibility_pane">
      <div class="ef-layout-grid">
        <div class="ef-layout-grid__cell--span-12 iframe__component">
          <div class="iframe__top-bar">
            <a class="btn btn-primary btn-compact" rel="noopener noreferrer" href="#developer/accessibility">Full Course
              Accessibility Report</a>
            <a class="btn btn-primary btn-compact" rel="noopener noreferrer"
              href="https://chrome.google.com/webstore/detail/accessibility-developer-t/fpkknkljclfencbdbgkenhalefipecmb?hl=en"
              target="_blank">Google Audit Extension</a>
            <a class="btn btn-primary btn-compact" rel="noopener noreferrer"
              href="https://chrome.google.com/webstore/detail/wave-evaluation-tool/jbbplnpkjmmeebjpijfedlgcdilocofh?hl=en"
              target="_blank">WAVE Extension</a>
            <button class="btn btn-primary btn-compact" id="refresh_achecker">Refresh AChecker</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
